import React, { FC, useEffect, useMemo, useState } from 'react';
import { RouteComponentProps, useParams } from 'react-router-dom';
import { getWalletAwardById } from '../../../network/awardCrud';
import { WalletAwardFormMode } from '../../../types/award-type';
import { NOT_FOUND_ERROR_PAGE_PATH } from '../../../../../common/constants';
import { useDispatch } from 'react-redux';
import { ApiErrorResponse } from 'src/app/common/network';
import { LayoutSplashScreen } from 'src/app/layout';
import AwardDetail from './components/AwardDetail';
import { GetWalletAwardDetail } from './components/AwardDetail.util';

const AwardDetailPage: FC<RouteComponentProps> = ({ history }) => {
  const { id } = useParams<{ id: string }>();

  const { formMode, code } = useMemo(
    () => ({
      formMode: id
        ? window.location.href.endsWith(`/view/${id}`)
          ? WalletAwardFormMode.VIEW
          : WalletAwardFormMode.EDIT
        : WalletAwardFormMode.CREATE,
      code: id ? id : undefined,
    }),
    [id],
  );

  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [detail, setDetail] = useState<GetWalletAwardDetail>();

  const reloadData = () => {
    if (code) {
      setIsLoading(true);
      getWalletAwardById(code, dispatch)
        .then(async (result) => {
          setDetail(result);
        })
        .catch((err: ApiErrorResponse) => {
          history.push(NOT_FOUND_ERROR_PAGE_PATH);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    reloadData();
  }, [code]);

  return (
    <>
      {formMode === WalletAwardFormMode.CREATE && (
        <AwardDetail formMode={formMode} onReload={reloadData} onRouteTo={(route) => history.push(route)} />
      )}
      {(formMode === WalletAwardFormMode.EDIT || formMode === WalletAwardFormMode.VIEW) &&
        (isLoading || !detail ? (
          <LayoutSplashScreen />
        ) : (
          <AwardDetail
            code={code}
            formMode={formMode}
            detail={detail}
            onReload={reloadData}
            onRouteTo={(route) => history.push(route)}
          />
        ))}
    </>
  );
};

export default AwardDetailPage;
